export default (state = {}) => {
  return {
    ...state,
    userId: null,
  };
};
